import React from 'react';
import { Chip } from '@mui/material';

/**
 * Renders a task category as a coloured chip. Pass `category` = the task's
 * `category_info` ({ key, label, color }) from the API. Renders nothing if unset.
 */
function CategoryChip({ category, size = 'small', sx }) {
  if (!category || !category.label) return null;
  return (
    <Chip
      size={size}
      label={category.label}
      sx={{
        bgcolor: category.color || '#9e9e9e',
        color: '#fff',
        fontWeight: 500,
        ...sx,
      }}
    />
  );
}

export default CategoryChip;
